/**
 * Unique, order-preserving values for Information Manager column filters.
 * Empty / blank entries are omitted so ColumnFilter can treat an empty array as (Blank).
 */

export const TASK_LINKED_FILTER_FIELD = 'tasklistFilterValues';
export const LOCATION_FILTER_FIELD = 'locationFilterValues';
export const TASK_CATEGORY_FILTER_FIELD = 'taskCategoryFilterValues';

const HEADER_TO_FILTER_FIELD = {
  tasklist: TASK_LINKED_FILTER_FIELD,
  location: LOCATION_FILTER_FIELD,
  task_category: TASK_CATEGORY_FILTER_FIELD,
};

function uniqueNonEmpty(values) {
  const seen = new Set();
  const result = [];
  (values || []).forEach((value) => {
    if (value === null || value === undefined || value === '') return;
    const key = String(value);
    if (!seen.has(key)) {
      seen.add(key);
      result.push(value);
    }
  });
  return result;
}

export function getLinkedTaskEntries(item) {
  if (Array.isArray(item?.tasklist) && item.tasklist.length) {
    return item.tasklist;
  }
  if (Array.isArray(item?.checklist_id)) {
    return item.checklist_id;
  }
  return [];
}

export function buildTaskLinkedFilterValues(links, getTask) {
  return uniqueNonEmpty(
    (links || []).map((link) => {
      const task = typeof getTask === 'function' ? getTask(link?.checklist_id) : null;
      return task && task.ref ? task.ref : '';
    })
  );
}

export function buildLocationFilterValues(links, getLocationName) {
  return uniqueNonEmpty(
    (links || []).map((link) => {
      return typeof getLocationName === 'function' ? getLocationName(link?.location) : '';
    })
  );
}

export function buildTaskCategoryFilterValues(links, getTask) {
  return uniqueNonEmpty(
    (links || []).map((link) => {
      const task = typeof getTask === 'function' ? getTask(link?.checklist_id) : null;
      return task && task.category ? task.category : '';
    })
  );
}

/**
 * ColumnFilter keys selections by header.value. Display rows keep tasklist as
 * link objects and location as the first-name string, so matching uses the
 * parallel primitive arrays built in formateData.
 */
export function normalizeInfoManagerFilterCriteria(criteria) {
  if (!criteria || typeof criteria !== 'object') return criteria;
  const mapped = { ...criteria };
  Object.keys(HEADER_TO_FILTER_FIELD).forEach((headerValue) => {
    if (Object.prototype.hasOwnProperty.call(mapped, headerValue)) {
      mapped[HEADER_TO_FILTER_FIELD[headerValue]] = mapped[headerValue];
      delete mapped[headerValue];
    }
  });
  return mapped;
}
